import { useEffect, useState } from "react";

import classnames from "classnames";
import { useBreakpoints } from "neetocommons/react-utils";
import { Close } from "neetoicons";
import { Button } from "neetoui";

import EmptyProperty from "./EmptyProperty";
import Skeleton from "./Skeleton";

import "../styles.scss";

const PropertiesPanel = ({ id, children, onClose }) => {
  const { isSize } = useBreakpoints(window => ({
    largeDesktop: window.innerWidth >= 1280,
  }));
  const isLargerScreen = isSize("largeDesktop");
  const [isPropertiesPanelCollapsed, setIsPropertiesPanelCollapsed] =
    useState(!isLargerScreen);

  useEffect(() => {
    setIsPropertiesPanelCollapsed(!isLargerScreen);
  }, [isLargerScreen]);

  useEffect(() => {
    if (!id) return;
    setIsPropertiesPanelCollapsed(false);
  }, [id]);

  const handleCollapsePanel = () => {
    setIsPropertiesPanelCollapsed(!isPropertiesPanelCollapsed);
    onClose?.(id);
  };

  return (
    <>
      {!isPropertiesPanelCollapsed && (
        <div
          className="neeto-molecules-builder-panel__backdrop neeto-molecules-builder-panel__backdrop--extended"
          onClick={handleCollapsePanel}
        />
      )}
      <div
        className={classnames(
          "neeto-molecules-builder-element-properties-panel__wrapper",
          {
            "neeto-molecules-builder-element-properties-panel__wrapper--collapsed":
              isPropertiesPanelCollapsed,
          }
        )}
      >
        <div
          className="neeto-molecules-builder-element-properties-panel neeto-ui-bg-white"
          data-testid="properties-panel"
        >
          {children ?? <Skeleton />}
        </div>
        {!isPropertiesPanelCollapsed && (
          <Button
            className="neeto-molecules-builder-properties-panel__close"
            icon={Close}
            style="secondary"
            onClick={handleCollapsePanel}
          />
        )}
      </div>
    </>
  );
};

PropertiesPanel.EmptyProperty = EmptyProperty;

export default PropertiesPanel;
